interface Props {
  title: string;
  label1: string;
  name1: string;
  label2: string;
  name2: string;
  isRequired: boolean;
  register: (name: any) => Record<string, unknown>;
  errors: any;
}

const required = () => (
  <span
    className="text-danger ms-1"
    style={{
      fontWeight: 'bold',
      fontSize: '1rem',
    }}
  >
    *
  </span>
);

const handleErrors = (errors: any, name: string) => {
  if (errors[name]) {
    return (
      <span className="d-flex text-danger align-items-center justify-content-center">
        {errors[name]?.message}
      </span>
    );
  }
  return null;
};

const MultiInput = (
  {
    title,
    label1,
    name1,
    label2,
    name2,
    isRequired,
    register,
    errors,
  }: Props,
) => (
  <div className="row g-3 mb-3">
    <label className="col-form-label col-sm-3 text-sm-start">
      {title}
      {isRequired && required()}
    </label>
    <div className="col-sm-9">
      <div className="is-invalid" id="validatione1">
        <div className="row g-3">
          <div className="col-md-6">
            <div className="d-flex align-items-center gap-2">
              <label className="form-label mb-0 text-nowrap">{label1}</label>
              <input className={`form-control ${errors[name1] ? 'is-invalid' : ''}`} type="text" name={name1} {...register(name1)} />
            </div>
            {handleErrors(errors, name1)}
          </div>
          <div className="col-md-6">
            <div className="d-flex align-items-center gap-2">
              <label className="form-label mb-0 text-nowrap">{label2}</label>
              <input className={`form-control ${errors[name2] ? 'is-invalid' : ''}`} type="text" name={name2} {...register(name2)} />
            </div>
            {handleErrors(errors, name2)}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default MultiInput;
